<template>
    <div>
        <div class="card__avatar">
            <common-rating-avatar
                v-if="practice"
                :showPracticeAvatar="true"
                :rating="practice.professionalRating"
                :user="practice"
                :size="avatarSize"
                :isUserProfileLinkEnabled="false"
            ></common-rating-avatar>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            practice: { type: Object, required: true },
            size: { type: String, default: 'large' },
            isUserProfileLinkEnabled: { type: Boolean, default: true },
        },

        computed: {
            avatarSize() {
                switch (this.size) {
                    case 'medium':
                        return 'user-context'
                    default:
                        return 'member-switch'
                }
            },
        },
    }
</script>
